import { useRouter } from 'next/router'
import { ProductPriceList } from '../types'
import { useTranslation } from 'next-i18next/pages'
import { CUSTOMER_TYPES } from '@boltenergy-be/shared'

const PricelistLine = ({ product, name, pricelists }: ProductPriceList) => {
  // Next router
  const { locale } = useRouter()

  // i18n
  const { t } = useTranslation('pricelists')

  return (
    <li key={`el-${product}`}>
      {name}: &nbsp;
      {/* RESIDENTIAL */}
      <a href={`https://${pricelists[CUSTOMER_TYPES.residential][locale]}`} target="_blank" rel="noreferrer">
        {t('res')}
      </a>
      &nbsp; / &nbsp;
      {/* PROFESSIONAL */}
      <a href={`https://${pricelists[CUSTOMER_TYPES.professional][locale]}`} target="_blank" rel="noreferrer">
        {t('pro')}
      </a>
    </li>
  )
}

export default PricelistLine
